import { useEffect, useState } from "react"

/**
 *
 * @param {boolean} loadingState
 * @param {number} delay the delay in milliseconds
 * @returns
 */
export const useDelayLoading = (loadingState, delay = 200) => {
	const [loading, setLoading] = useState(false)
	useEffect(() => {
		let timer
		if (loadingState === true && !loading) {
			timer = setTimeout(() => {
				setLoading(true)
			}, delay)
		} else if (loadingState === false && loading === true) {
			setLoading(false)
		} else if (loadingState === false && loading === false) {
			setLoading(false)
			clearTimeout(timer)
		}
		return () => {
			setLoading(false)
			clearTimeout(timer)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loadingState])

	return loading
}
